import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	selectPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sourceTypeFieldLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	teamTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	teamSelectedTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	teamDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	issueTypesTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	issueTypesSelectedTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	issueTypesDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	labelsTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	labelsSelectedTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	labelsDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	allIssuesFromProjectTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	allIssuesFromProjectSelectedTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	savedFilterTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	savedFilterSelectedTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	savedFilterDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sourceTypePickerAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sourceTypeEmptyError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	teamSelectedTitleIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	teamDescriptionIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	issueTypesTitleIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	issueTypesSelectedTitleIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	issueTypesDescriptionIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	labelsSelectedTitleIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	labelsDescriptionIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	allIssuesFromProjectTitleIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	allIssuesFromProjectSelectedTitleIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	savedFilterSelectedTitleIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	savedFilterDescriptionIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	allIssuesFromProjectTitleIssueTerminologyRefreshM4Galaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	allIssuesFromProjectSelectedTitleIssueTerminologyRefreshM4Galaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	selectPlaceholder: {
		id: 'software-board-create.modal.form.source-type-picker.select-placeholder',
		defaultMessage: 'Select',
		description: 'Placeholder for the source type selector',
	},
	sourceTypeFieldLabel: {
		id: 'software-board-create.modal.form.source-type-picker.source-type-field-label',
		defaultMessage: 'Choose what to include in this board',
		description:
			'Label for the field which asks the user to select sources for the new board they are creating',
	},
	teamTitle: {
		id: 'software-board-create.modal.form.source-type-picker.team-title',
		defaultMessage: 'Team',
		description: 'Label for the team source type dropdown option',
	},
	teamSelectedTitle: {
		id: 'software-board-create.modal.form.source-type-picker.team-selected-title',
		defaultMessage: 'Issues based on <strong>Team</strong>',
		description: 'Label for when team is selected as the source type of the new board',
	},
	teamDescription: {
		id: 'software-board-create.modal.form.source-type-picker.team-description',
		defaultMessage: 'Show all issues assigned to a team',
		description: 'Description for the team source type dropdown option',
	},
	issueTypesTitle: {
		id: 'software-board-create.modal.form.source-type-picker.issue-types-title',
		defaultMessage: 'Issue type',
		description: 'Label for the issue types source type option',
	},
	issueTypesSelectedTitle: {
		id: 'software-board-create.modal.form.source-type-picker.issue-types-selected-title',
		defaultMessage: 'Issues based on <strong>Issue type</strong>',
		description: 'Label for when issue type is selected as the source type of the new board',
	},
	issueTypesDescription: {
		id: 'software-board-create.modal.form.source-type-picker.issue-types-description',
		defaultMessage: 'Show all issues associated with an issue type',
		description: 'Description for the issue types source type option',
	},
	labelsTitle: {
		id: 'software-board-create.modal.form.source-type-picker.labels-title',
		defaultMessage: 'Label',
		description: 'Label for the labels source type option',
	},
	labelsSelectedTitle: {
		id: 'software-board-create.modal.form.source-type-picker.labels-selected-title',
		defaultMessage: 'Issues based on <strong>Label</strong>',
		description: 'Label for when labels is selected as the source type of the new board',
	},
	labelsDescription: {
		id: 'software-board-create.modal.form.source-type-picker.labels-description',
		defaultMessage: 'Show all issues tagged with a specific label',
		description: 'Description for the labels source type option',
	},
	allIssuesFromProjectTitle: {
		id: 'software-board-create.modal.form.source-type-picker.all-issues-from-project-title',
		defaultMessage: 'All issues from your project',
		description:
			'Text shown in the closed dropdown when the all issues from your project source type option is selected',
	},
	allIssuesFromProjectSelectedTitle: {
		id: 'software-board-create.modal.form.source-type-picker.all-issues-from-project-selected-title',
		defaultMessage: 'Issues based on <strong>All issues from your project</strong>',
		description:
			'Label for when "All issues in project" is selected as the source type of the new board',
	},
	savedFilterTitle: {
		id: 'software-board-create.modal.form.source-type-picker.saved-filter-title',
		defaultMessage: 'Advanced',
		description: 'Label for the saved filters source type dropdown option',
	},
	savedFilterSelectedTitle: {
		id: 'software-board-create.modal.form.source-type-picker.saved-filter-selected-title',
		defaultMessage: 'Issues based on a <strong>Saved filter</strong>',
		description: 'Label for when issue type is selected as the source type of the new board',
	},
	savedFilterDescription: {
		id: 'software-board-create.modal.form.source-type-picker.saved-filter-description',
		defaultMessage: 'Show issues from a saved JQL filter',
		description: 'Description for the saved filters source type dropdown option',
	},
	sourceTypePickerAriaLabel: {
		id: 'software-board-create.modal.form.source-type-picker.source-type-picker-aria-label',
		defaultMessage: 'Select what to include in this board',
		description: 'Label for the source type selector',
	},
	sourceTypeEmptyError: {
		id: 'software-board-create.modal.form.source-type-picker.source-type-empty-error',
		defaultMessage: 'Select what to include in this board',
		description:
			'Error message for board source type telling the user that board source is required to create a board',
	},
	teamSelectedTitleIssueTerminologyRefreshM4: {
		id: 'software-board-create.modal.form.source-type-picker.team-selected-title-issue-terminology-refresh-m4',
		defaultMessage: 'Work items based on <strong>Team</strong>',
		description: 'Label for when team is selected as the source type of the new board',
	},
	teamDescriptionIssueTerminologyRefreshM4: {
		id: 'software-board-create.modal.form.source-type-picker.team-description-issue-terminology-refresh-m4',
		defaultMessage: 'Show all work items assigned to a team',
		description: 'Description for the team source type dropdown option',
	},
	issueTypesTitleIssueTerminologyRefreshM4: {
		id: 'software-board-create.modal.form.source-type-picker.issue-types-title-issue-terminology-refresh-m4',
		defaultMessage: 'Work type',
		description: 'Label for the issue types source type option',
	},
	issueTypesSelectedTitleIssueTerminologyRefreshM4: {
		id: 'software-board-create.modal.form.source-type-picker.issue-types-selected-title-issue-terminology-refresh-m4',
		defaultMessage: 'Work items based on <strong>work type</strong>',
		description: 'Label for when issue type is selected as the source type of the new board',
	},
	issueTypesDescriptionIssueTerminologyRefreshM4: {
		id: 'software-board-create.modal.form.source-type-picker.issue-types-description-issue-terminology-refresh-m4',
		defaultMessage: 'Show all work items associated with a work type',
		description: 'Description for the issue types source type option',
	},
	labelsSelectedTitleIssueTerminologyRefreshM4: {
		id: 'software-board-create.modal.form.source-type-picker.labels-selected-title-issue-terminology-refresh-m4',
		defaultMessage: 'Work items based on <strong>label</strong>',
		description: 'Label for when labels is selected as the source type of the new board',
	},
	labelsDescriptionIssueTerminologyRefreshM4: {
		id: 'software-board-create.modal.form.source-type-picker.labels-description-issue-terminology-refresh-m4',
		defaultMessage: 'Show all work items tagged with a specific label',
		description: 'Description for the labels source type option',
	},
	allIssuesFromProjectTitleIssueTerminologyRefreshM4: {
		id: 'software-board-create.modal.form.source-type-picker.all-issues-from-project-title-issue-terminology-refresh-m4',
		defaultMessage: 'All work items from your project',
		description:
			'Text shown in the closed dropdown when the all issues from your project source type option is selected',
	},
	allIssuesFromProjectSelectedTitleIssueTerminologyRefreshM4: {
		id: 'software-board-create.modal.form.source-type-picker.all-issues-from-project-selected-title-issue-terminology-refresh-m4',
		defaultMessage: 'Work items based on <strong>All work items from your project</strong>',
		description:
			'Label for when "All issues in project" is selected as the source type of the new board',
	},
	savedFilterSelectedTitleIssueTerminologyRefreshM4: {
		id: 'software-board-create.modal.form.source-type-picker.saved-filter-selected-title-issue-terminology-refresh-m4',
		defaultMessage: 'Work items based on a <strong>Saved filter</strong>',
		description: 'Label for when issue type is selected as the source type of the new board',
	},
	savedFilterDescriptionIssueTerminologyRefreshM4: {
		id: 'software-board-create.modal.form.source-type-picker.saved-filter-description-issue-terminology-refresh-m4',
		defaultMessage: 'Show work items from a saved JQL filter',
		description: 'Description for the saved filters source type dropdown option',
	},
	allIssuesFromProjectTitleIssueTerminologyRefreshM4Galaxia: {
		id: 'software-board-create.modal.form.source-type-picker.all-issues-from-project-title-issue-terminology-refresh-m4-galaxia',
		defaultMessage: 'All work items from your space',
		description:
			'Text shown in the closed dropdown when the all issues from your project source type option is selected',
	},
	allIssuesFromProjectSelectedTitleIssueTerminologyRefreshM4Galaxia: {
		id: 'software-board-create.modal.form.source-type-picker.all-issues-from-project-selected-title-issue-terminology-refresh-m4-galaxia',
		defaultMessage: 'Work items based on <strong>All work items from your space</strong>',
		description:
			'Label for when "All issues in project" is selected as the source type of the new board',
	},
});
export default messages;
